import Icon from '@mdi/react';
import { Button } from '@nestle-npus-nbm/pds-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { mdiClose } from 'src/assets/icons/mdiIcons';
import { CMS_THEME } from 'src/common/enums';
import { ButtonLink } from '../Link';
import ButtonDiadWrapper from '../button/ButtonDiadWrapper';
import { CmsButton } from '../button/CmsButton';
import { IGeoLocationConfig } from './useGetGeoLocationConfig';

interface MarketBannerProps {
  onDismiss: (action: 'close' | 'purina_us') => void;
  onGoToLocal: () => void;
  geolocationConfig: IGeoLocationConfig;
}

export const MarketBanner: React.FC<MarketBannerProps> = ({
  onDismiss,
  onGoToLocal,
  geolocationConfig,
}) => {
  const { t } = useTranslation();
  return (
    <div className="pds-relative pds-flex pds-flex-col pds-items-center pds-justify-center pds-gap-4 pds-bg-neutral pds-p-4 pds-text-neutral-text md:pds-flex-row">
      <div className="pds-flex pds-gap-4">
        <span className="pds-text-title-sm pds-font-extrabold">{geolocationConfig.text}</span>
        <CmsButton
          cmsTheme={CMS_THEME.DARK}
          buttonStyle="tonal"
          onClick={() => onDismiss('close')}
          aria-label={t('Close location notification')}
          className="pds-block pds-border-none pds-bg-transparent pds-px-3 pds-py-0 md:pds-hidden"
        >
          <Icon path={mdiClose} size={1} aria-hidden />
        </CmsButton>
      </div>

      <ButtonDiadWrapper className="pds-flex pds-flex-shrink-0 pds-items-center">
        <ButtonLink
          to={geolocationConfig.siteUrl}
          analytics={false}
          buttonColor="inverse"
          buttonStyle="solid"
          className="pds-px-4"
          onClick={onGoToLocal}
          target="_blank"
          rel="noopener noreferrer"
        >
          {geolocationConfig.leaveText}
        </ButtonLink>

        <Button
          buttonColor="inverse"
          buttonStyle="outlined"
          className="pds-px-4"
          onClick={() => onDismiss('purina_us')}
        >
          {geolocationConfig.stayText}
        </Button>

        <CmsButton
          cmsTheme={CMS_THEME.DARK}
          buttonStyle="tonal"
          onClick={() => onDismiss('close')}
          aria-label={t('Close location notification')}
          className="pds-hidden pds-border-none pds-bg-transparent pds-px-3 pds-py-0 md:pds-block"
        >
          <Icon path={mdiClose} size={1} aria-hidden />
        </CmsButton>
      </ButtonDiadWrapper>
    </div>
  );
};
